import * as React from 'react';
import {connect} from 'react-redux';

import {RootState} from '../../../../store/State';
import {InfoList} from '../../../components/InfoList/InfoList';

interface Props {
    name: string;
    email: string;
}

const ProfileSettingsComponent: React.FC<Props> = (props) => {
    const {name, email} = props;

    return (
        <InfoList
            data={[
                {label: 'Account Info'},
                {label: 'Name', value: name},
                {label: 'Email', value: email}
            ]}
        />
    );
};

const mapState = (state: RootState) => ({
    email: `${state.authentication.account.email}`,
    name: `${state.authentication.account.firstName} ${state.authentication.account.lastName}`
});

export const ProfileSettings = connect(mapState)(ProfileSettingsComponent);
